"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipMobile = void 0;
var _uiKit = require("@cian/ui-kit");
var React = _interopRequireWildcard(require("react"));
var styles = _interopRequireWildcard(require("./Tooltip.css"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const TooltipMobile = _ref => {
  let {
    content,
    title,
    toggleVisibility,
    opened,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: toggleVisibility,
    className: styles['tooltip-trigger']
  }, children), /*#__PURE__*/React.createElement(_uiKit.ModalWindow, {
    title: title,
    content: content,
    onClose: toggleVisibility,
    fixed: true,
    footer: /*#__PURE__*/React.createElement(_uiKit.Button, {
      theme: "fill_primary",
      onClick: toggleVisibility,
      fullWidth: true,
      size: "L"
    }, "\u041F\u043E\u043D\u044F\u0442\u043D\u043E"),
    open: opened,
    portal: true
  }));
};
exports.TooltipMobile = TooltipMobile;